/*  errorModal(this, 'Title', 'message', 'button1Title')
*/

export default async function(that, errorId, err) {
   if (err) console.error(err.toString())

   const [title, message, okTitle] = [
      that.__('err:'+errorId+'-title'),
      that.__('err:'+errorId+'-message'),
      that.__('err:'+errorId+'-button')
   ]
   return await that.$bvModal.msgBoxOk(message, {
      title,
      okTitle,
      hideHeaderClose: true,
      centered: true
   })
 }

